import React, {useEffect} from 'react'
import './experience.css'
import {DiPhp,DiPhotoshop,DiIllustrator, DiMongodb, DiPostgresql} from 'react-icons/di'
import {SiJavascript, SiNestjs} from 'react-icons/si'
import {GrMysql} from 'react-icons/gr'
import {SiTailwindcss} from 'react-icons/si'
import {FiFigma, FiSettings} from 'react-icons/fi'
import {RiFlutterFill} from 'react-icons/ri'
import {
  FaHtml5,
  FaCss3,
  FaBootstrap,
  FaReact,
  FaLaravel,
  FaSymfony,
  FaAngular,
} from "react-icons/fa";
import {gsap} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import { motion } from 'framer-motion';

gsap.registerPlugin(ScrollTrigger)

const Experience = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const Left = (element, delay, duration) => {
        gsap.fromTo(
            element,{
                opacity : 0,
                x: -200
            },
            {
                opacity : 1,
                x: 0,
                delay: delay || "0.3",
                duration: duration || "0.4",
                scrollTrigger:{
                    trigger: element,
                    start: "top center",
                    end: "bottom center"
                }
            }
        )
  }
  useEffect(() => {
        Left("#experience")
    }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section id="experience">
      <motion.h5
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        {t.skillsTitle}
      </motion.h5>

      <motion.h2
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
        {t.skillsSubtitle}
      </motion.h2>

      <div className="container experience__container">
        <motion.div
          className="experience__frontend"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <h3 className="text-light">{t.frontendTitle}</h3>
          <motion.div
            className="experience__content"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <FaHtml5 className="experience_article-icon" />
              <div>
                <h4>HTML</h4>
                <small className="text-light">{t.experienced}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <FaCss3 className="experience_article-icon" />
              <div>
                <h4>CSS</h4>
                <small className="text-light">{t.good}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <SiJavascript className="experience_article-icon" />
              <div>
                <h4>JavaScript</h4>
                <small className="text-light">{t.experienced}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <FaReact className="experience_article-icon" />
              <div>
                <h4>ReactJs</h4>
                <small className="text-light">{t.experienced}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <FaAngular className="experience_article-icon" />
              <div>
                <h4>Angular 16</h4>
                <small className="text-light">{t.good}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <FaBootstrap className="experience_article-icon" />
              <div>
                <h4>Bootstrap</h4>
                <small className="text-light">{t.experienced}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <SiTailwindcss className="experience_article-icon" />
              <div>
                <h4>Tailwindcss</h4>
                <small className="text-light">{t.experienced}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <RiFlutterFill className="experience_article-icon" />
              <div>
                <h4>Flutter</h4>
                <small className="text-light">{t.good}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <FaReact className="experience_article-icon" />
              <div>
                <h4>React Native</h4>
                <small className="text-light">{t.good}</small>
              </div>
            </motion.article>
          </motion.div>
        </motion.div>

        <motion.div
          className="experience__backend"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
          viewport={{ once: true }}
        >
          <h3>{t.backendTitle}</h3>
          <motion.div
            className="experience__content"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <DiPhp className="experience_article-icon" />
              <div>
                <h4>PHP</h4>
                <small className="text-light">{t.experienced}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <FaLaravel className="experience_article-icon" />
              <div>
                <h4>Laravel</h4>
                <small className="text-light">{t.experienced}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <SiNestjs className="experience_article-icon" />
              <div>
                <h4>NestJs</h4>
                <small className="text-light">{t.experienced}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <FaSymfony className="experience_article-icon" />
              <div>
                <h4>Symfony</h4>
                <small className="text-light">{t.good}</small>
              </div>
            </motion.article>
          </motion.div>
        </motion.div>

        <motion.div
          className="experience__backend"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.7 }}
          viewport={{ once: true }}
        >
          <h3>{t.databaseTitle}</h3>
          <motion.div
            className="experience__content"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <GrMysql className="experience_article-icon" />
              <div>
                <h4>MySql</h4>
                <small className="text-light">{t.experienced}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <DiPostgresql className="experience_article-icon" />
              <div>
                <h4>PostgreSQL</h4>
                <small className="text-light">{t.good}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <DiMongodb className="experience_article-icon" />
              <div>
                <h4>Mongodb</h4>
                <small className="text-light">{t.good}</small>
              </div>
            </motion.article>
          </motion.div>
        </motion.div>

        <motion.div
          className="experience__infographie"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.9 }}
          viewport={{ once: true }}
        >
          <h3>{t.uiDesignTitle}</h3>
          <motion.div
            className="experience__content"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <DiPhotoshop className="experience_article-icon" />
              <div>
                <h4>Photoshop</h4>
                <small className="text-light">{t.experienced}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <DiIllustrator className="experience_article-icon" />
              <div>
                <h4>Illustrator</h4>
                <small className="text-light">{t.good}</small>
              </div>
            </motion.article>
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <FiFigma className="experience_article-icon" />
              <div>
                <h4>Figma</h4>
                <small className="text-light">{t.good}</small>
              </div>
            </motion.article>
          </motion.div>
        </motion.div>

        <motion.div
          className="experience__autres"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.1 }}
          viewport={{ once: true }}
        >
          <h3>{t.othersTitle}</h3>
          <motion.div
            className="experience__content"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <motion.article
              className="experience__article"
              variants={itemVariants}
            >
              <FiSettings className="experience_article-icon" />
              <div>
                <h4>{t.computerMaintenance}</h4>
                <small className="text-light">{t.good}</small>
              </div>
            </motion.article>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

export default Experience